<template>
    <v-container fluid class="scroll-y fullscreen" pa-0>
        <v-card
            class="mx-auto"
            flat
            :loading="loading"
            loader-height="10"
            tile
        >
            <v-toolbar
            color="accent"
            dark
            flat
            >
                <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card flat tile class="mx-auto overflow-hidden" min-height="calc(100vh - 112px)" color="accent">
            <v-card flat color="accent">
                <v-card-text class="pa-0">
                    <ValidationObserver ref="observer1">
                        <v-form ref="personalform">
                            <v-list flat color="accent" class="py-0">
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Owner</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Owner" rules="required">
                                            <v-text-field
                                            v-model="form.owner"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Street Address</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Street Address" rules="required">
                                            <v-text-field
                                            v-model="form.street_address"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">City</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="City" rules="required">
                                            <v-text-field
                                            v-model="form.city"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">ZIP Code</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Zip Code" rules="required">
                                            <v-text-field
                                            v-model="form.zip"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">State</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="State" rules="required">
                                            <v-autocomplete
                                                :items="states"
                                                :error-messages="errors"
                                                v-model="form.state"
                                                item-text="label"
                                                item-value="value"
                                                color="white"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Building Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Building Type" rules="required">
                                            <v-autocomplete
                                                :items="building_types"
                                                :error-messages="errors"
                                                v-model="form.building_type"
                                                color="white"
                                                item-text="label"
                                                item-value="value"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">SQFT</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="SQFT" rules="required">
                                            <v-text-field
                                            v-model="form.sqft"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Acres</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Acres" rules="required">
                                            <v-text-field
                                            v-model="form.acres"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Year Purchased</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Year Purchased" rules="required">
                                            <v-autocomplete
                                                :items="years"
                                                :error-messages="errors"
                                                v-model="form.year_purchased"
                                                color="white"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Purchased Price</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Purchased Price" rules="required">
                                            <v-text-field
                                            v-model="form.purchased_price"
                                            :error-messages="errors"
                                            required
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Construction Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Construction Type" rules="required">
                                            <v-autocomplete
                                                :items="construction_types"
                                                :error-messages="errors"
                                                v-model="form.construction_type"
                                                color="white"
                                                item-text="label"
                                                item-value="value"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Roof Type</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Roof Type" rules="required">
                                            <v-autocomplete
                                                :items="roof_types"
                                                :error-messages="errors"
                                                v-model="form.roof_type"
                                                color="white"
                                                item-text="label"
                                                item-value="value"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Status</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Status" rules="required">
                                            <v-select
                                                :items="statuses"
                                                :error-messages="errors"
                                                v-model="form.status"
                                                color="white"
                                                item-text="label"
                                                item-value="value"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-select>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                               <v-list-item class="form-row w-50">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Year Built</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <ValidationProvider v-slot="{ errors }" name="Year Built" rules="required">
                                            <v-autocomplete
                                                :items="years"
                                                :error-messages="errors"
                                                v-model="form.year_built"
                                                color="white"
                                                required
                                                solo
                                                flat
                                                dark
                                            ></v-autocomplete>
                                        </ValidationProvider>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-100">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Position/Order</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                            <v-text-field
                                            v-model="form.position"
                                            solo
                                            flat
                                            dark
                                            ></v-text-field>
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-100">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Capital Improvement</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-textarea
                                            v-model="form.capital_improvement"
                                            required
                                            solo
                                            dark
                                            flat
                                        ></v-textarea> 
                                    </v-list-item-action>
                                </v-list-item>
                                <v-list-item class="form-row w-100">
                                    <v-list-item-content class="label">
                                        <v-list-item-title class="font-weight-bold">Notes</v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-textarea
                                            v-model="form.notes"
                                            required
                                            solo
                                            dark
                                            flat
                                        ></v-textarea> 
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list>
                        </v-form>
                    </ValidationObserver>
                </v-card-text> 
                <v-card-actions>
                    <v-btn large min-width="50%" color="white"  to="/properties" text tile depressed>Cancel</v-btn>
                    <v-btn large min-width="50%" color="primary"  @click="submit" :loading="loading" tile depressed>Create</v-btn>
                </v-card-actions> 
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { required } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import mixin from '../../mixin/main.js'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

export default {
    mixins: [mixin],
    data () {
        return {
            form: {
                owner: '',
                street_address: '',
                city: '',
                state: 'AL',
                zip: '',
                building_type: '',
                sqft: '',
                acres: '',
                year_purchased: '',
                purchased_price: '',
                construction_type: '',
                roof_type: '',
                year_built: '',
                status: 'active',
                capital_improvement: '',
                notes: '',
                county: '',
                position: ''
            },
            pageTitle: '',
            loading: false,
            yesno: [
                { label: 'Yes', value: 1},
                { label: 'No', value: 0}
            ],
            voptions: {
                toolbar: true,
                url: 'data-source'
            },
            requiredValue: true,
            menu: false,
        }
    },
    created() {
        this.pageTitle = this.$route.meta.title
    },
    computed: {
        ...mapGetters({
            building_types: 'data/building_types',
            construction_types: 'data/construction_types',
            roof_types: 'data/roof_types',
            statuses: 'data/statuses',
            states: 'data/states'
        }),
    },
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    methods: {
        ...mapActions({
            addProperty: 'data/addProperty'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.addProperty(this.form).then(response => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.$router.push({ path: `/property/edit/${response.id}` })
                }).catch(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>